import React, { FC, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Layout, message } from 'antd';
import RequestForProposalForm from '../request_for_proposal_form/RequestForProposalForm';
import { BIDDERS_CRUD_ACTION_CREATORS } from '../../actions/bidders_actions';
import LogOnMountWithStandardEventProperties from '../log_on_mount_with_standard_event_properties/LogOnMountWithStandardEventProperties';
import { ROLE_TYPES } from '../../utils/DataConstants';
import {
	workOrdersRestCrudThunksForBuyer,
	workOrdersRestCrudThunksForSupplier,
} from '../../thunks/work_orders_thunks';
import { EditPage } from '../edit_page/EditPage';

const queryString = require('qs');
const { Content } = Layout;

const NewRequestForProposalPage: FC<any> = ({
	location,
	history,
	biddersFormData,
	clearBidders,
	userType,
	getWorkOrder,
}): React.ReactElement => {
	const [fetchingWorkOrder, setFetchingWorkOrder] = useState(false);
	const [workOrder, setWorkOrder] = useState(undefined);

	useEffect(() => {
		return () => clearBidders();
	}, [clearBidders]);

	const workOrderId = useMemo(() => {
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);
		return queryParams.workOrderId;
	}, [location.search]);

	useEffect(() => {
		if (!workOrderId) return;

		setFetchingWorkOrder(false);
		workOrderId &&
			getWorkOrder(workOrderId)
				.then(setWorkOrder)
				.catch(message.error)
				.finally(() => setFetchingWorkOrder(false));
	}, [workOrderId]);

	const updateBiddersFormData = useMemo(
		() => ({
			...biddersFormData,
			workOrderId,
			workOrder,
		}),
		[biddersFormData, workOrder, workOrderId]
	);

	return (
		<Content>
			<LogOnMountWithStandardEventProperties eventType="Visited RFP Form" />
			<EditPage
				title="New Request For Proposal"
				formComponentProps={{
					formData: updateBiddersFormData,
					onSuccess: (rec) => history.push(`/${userType}/requestsForProposal/detail/${rec.id}`),
				}}
				fetching={fetchingWorkOrder || !workOrder}
				FormComponent={RequestForProposalForm}
			/>
		</Content>
	);
};

const mapStateToProps = (state) => ({
	biddersFormData: state.bidders.formData,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	saveFormData: (formData) => dispatch(BIDDERS_CRUD_ACTION_CREATORS.saveFormData(formData)),
	clearBidders: () => dispatch(BIDDERS_CRUD_ACTION_CREATORS.clearFormData()),
	getWorkOrder: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? workOrdersRestCrudThunksForSupplier.readOne(id)
				: workOrdersRestCrudThunksForBuyer.readOne(id)
		),
});

const NewRFPPage = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(NewRequestForProposalPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(NewRFPPage);
